import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import LoginLogo from '@totem/components/logos/LoginLogo';
import accountUtilities from '@totem/components/userContext/accountUtilities';

import LoginForm from './LoginForm';

import './login.css';

const Login = () => {
  const { loginWithRedirect, logout, isAuthenticated } = useAuth0();
  const [cookiesCleared, setCookiesCleared] = useState<boolean>(false);

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin, // URL Auth0 redirects to after logout
      },
    });
  };

  useEffect(() => {
    if (!cookiesCleared) {
      setCookiesCleared(true);
      if (isAuthenticated) {
        handleLogout();
      }
      accountUtilities.logout();
    }
  }, []);

  const handleSubmit = (event: React.MouseEvent) => {
    event.preventDefault();

    loginWithRedirect();
  };

  return (
    <div styleName="container">
      <div
        styleName="middle-box loginscreen"
        className={'animate__animated animate__fadeInDown'}
      >
        <div styleName="login-header">
          <LoginLogo />
        </div>
        <h3 styleName="heading">Welcome back to the IntelliNet Portal!</h3>
        <p styleName="heading">Sign in to get started</p>
        <LoginForm onClick={handleSubmit} />
        <p styleName="m-t">
          <small styleName="heading">
            IntelliNet is a registered trademark of Intelligent Buildings, LLC.
          </small>
        </p>
      </div>
    </div>
  );
};

export default Login;
